__turbopack_context__.v({
  "badge": "EpexCalculator-module__TPCGya__badge",
  "buttonBlock": "EpexCalculator-module__TPCGya__buttonBlock",
  "calculationNote": "EpexCalculator-module__TPCGya__calculationNote",
  "calculator": "EpexCalculator-module__TPCGya__calculator",
  "cardHeader": "EpexCalculator-module__TPCGya__cardHeader",
  "errorBox": "EpexCalculator-module__TPCGya__errorBox",
  "formArea": "EpexCalculator-module__TPCGya__formArea",
  "helper": "EpexCalculator-module__TPCGya__helper",
  "hint": "EpexCalculator-module__TPCGya__hint",
  "inputBlock": "EpexCalculator-module__TPCGya__inputBlock",
  "metaLabel": "EpexCalculator-module__TPCGya__metaLabel",
  "metric": "EpexCalculator-module__TPCGya__metric",
  "metricSmall": "EpexCalculator-module__TPCGya__metricSmall",
  "periodLabel": "EpexCalculator-module__TPCGya__periodLabel",
  "resultPanel": "EpexCalculator-module__TPCGya__resultPanel",
  "resultRow": "EpexCalculator-module__TPCGya__resultRow",
  "sourceBlock": "EpexCalculator-module__TPCGya__sourceBlock",
  "title": "EpexCalculator-module__TPCGya__title",
});
